export default "__VITE_ASSET__BnmvxTuk__"